module.exports = __webpack_public_path__ + "static/media/timer_paused.11ef1f23.png";